<div [style.display]="displayHeader ? 'block' : 'none'">
  @if (!loading && headerData?.warning) {
    <div class="alert alert-danger" role="alert">
      <b [innerHTML]="headerData?.warning"></b>
    </div>
  }
  @if (!editMode) {
    <div class="entity-group-header" [style.background-color]="backgroundColor">
      @if (actionInProgress) {
        <div class="spinner-container">
          <mat-spinner [diameter]="32" color="accent"></mat-spinner>
        </div>
      }
      @if (!loading) {
        <div class="navigate-container">
          @if (code && menuConfig.menuType !== 'ENTITY_GROUP_SINGLE_FORM') {
            <a (click)="navigateBack()" class="navigate-link">
              <button mat-icon-button matTooltip="Go back to list">
                <mat-icon data-id="backArrowBtn" [style.color]="fontColor">keyboard_arrow_left</mat-icon>
              </button>
            </a>
          }
          <div class="form-image-container">
            @if (image) {
              <app-form-field-image class="image-holder" [data]="image"></app-form-field-image>
            }
            @if (title) {
              <span [innerHTML]="title"></span>
            }
            @if (groupConfig && groupConfig.label) {
              <span>&nbsp;/ {{ groupConfig.label }}</span>
            }
            <span class="action-buttons">
              <app-entity-group-tabs
                [menuConfig]="menuConfig"
                [baseUrl]="'./' + code + '/' + entityId"></app-entity-group-tabs>
              <app-entity-group-actions
                [menuConfig]="menuConfig"
                [headerConfig]="headerConfig"
                [headerData]="headerData"></app-entity-group-actions>
              <button mat-icon-button (click)="signalRefresh()" matTooltip="Refresh page">
                <mat-icon>refresh</mat-icon>
              </button>
            </span>
          </div>
          @if (headerConfig) {
            <div class="form-header">
              @for (column of headerConfig.rows[0].columns; track column) {
                <div>
                  @for (field of column.fields; track field) {
                    <div>
                      @if (!field.ignoreIfNotPresent || (field.ignoreIfNotPresent && headerData[field.name])) {
                        <div>
                          @if (!field.noLabel) {
                            <div>
                              <label>{{ field.label }}:</label>
                            </div>
                          }
                          <app-form-field
                            [type]="field.type"
                            [fieldConfig]="field"
                            [editMode]="false"
                            [formGroup]="formGroup"
                            [data]="headerData[field.name]"
                            [rowData]="headerData"></app-form-field>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
      <mat-menu #menu="matMenu">
        @if (!loading && headerConfig) {
          @for (action of headerConfig.actions; track action) {
            <app-action
              [data]="headerData"
              [actionConfig]="action"
              [menuItemMode]="true"
              (onActionStart)="forwardLoadingEmitter(true)"
              (onResponse)="forwardLoadingEmitter(false)"></app-action>
          }
        }
      </mat-menu>
      @if (loading) {
        <div class="bottom-loading">
          <mat-spinner [diameter]="34" class="spinner"></mat-spinner>
        </div>
      }
    </div>
  }
</div>
